import { Component, ViewChild, TemplateRef } from '@angular/core';
import { BzgModalService, BzgModalRef } from 'bz-genome-angular';
import { SyncDataImportComponent } from './import/sync-data-import.component';
import { SyncDataExportComponent } from './export/sync-data-export.component';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { SyncDataService } from './services/sync-data.service';
import { IAppState } from 'app/IAppState';
import { ISyncDataExportFile } from 'app/core/typings/ISyncDataExportFile';
import { ISyncDataImportFile } from 'app/core/typings/ISyncDataImportFile';

@Component({
  selector: 'biz-sync-data',
  templateUrl: './sync-data.component.html',
  styleUrls: ['./sync-data.component.scss']
})

export class SyncDataComponent {
  @ViewChild('importTemplate', { static: false}) importTemplate: TemplateRef<any>;
  @ViewChild('exportTemplate', { static: false}) exportTemplate: TemplateRef<any>;

  public options: any;
  private modalComponentRef: BzgModalRef;
  private _optionsSubscription: Subscription;

  private historyExportedInterval: any;
  private historyImportedInterval: any;

  historyExported: ISyncDataExportFile[];
  historyImported: ISyncDataImportFile[];

  constructor(private _modalService: BzgModalService,
    private _store: Store<IAppState>,
    private _syncDataService: SyncDataService) {
    this.historyExported = [];
    this.historyImported = [];
  }

  ngOnInit() {
    this._optionsSubscription = this._store
      .select((s) => s.menuOptions)
      .subscribe((menuOptions: any) => {
        this.options = menuOptions['SyncData'];
      });
      this.getExportedFiles();
      this.getImportedFiles();
      this.historyExportedInterval = setInterval(() => this.getExportedFiles(), 3000);
      this.historyImportedInterval = setInterval(() => this.getImportedFiles(), 3000);
  };

  ngOnDestroy() {
    this._optionsSubscription.unsubscribe();
    if (this.modalComponentRef) {
      this.modalComponentRef.close();
    }
    if (this.historyExportedInterval) {
      clearInterval(this.historyExportedInterval);
    }
    if (this.historyImportedInterval) {
      clearInterval(this.historyImportedInterval);
    }
  }

  private getExportedFiles() {
    this._syncDataService.getHistoryExportedFiles().then((history: ISyncDataExportFile[]) => {
      this.historyExported = history;
    });
  }

  private getImportedFiles() {
    this._syncDataService.getHistoryImportedFiles().then((history: ISyncDataImportFile[]) => {
      this.historyImported = history;
    });
  }

  public importFile() {
    this.modalComponentRef = this._modalService.open(this.importTemplate, {
      closeOnBackdropClick: false, maxWidth: '1000px', closeOnRouterNavigation: true
    });
  }

  public exportFile() {
    this.modalComponentRef = this._modalService.open(this.exportTemplate, {
      closeOnBackdropClick: false, closeOnRouterNavigation: true, maxWidth: '1000px'
    });
  }

  public closeModal() {
    this.modalComponentRef.close();
  }

}
